import { IntegrityMonitorRuleSetFormGzDataProvider } from '../dataProvider/IntegrityMonitorRuleSetFormGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';

export class IntegrityMonitorRuleSetFormDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, IntegrityMonitorRuleSetFormGzDataProvider);
  }
}
